const toDate = (value) => {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  if (value instanceof Date) return value;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const calculateNextDose = (medication, history = []) => {
  if (medication?.status !== "Active") return null;

  const { frequency, startDate } = medication;
  if (!frequency || typeof frequency !== "string" || !startDate) {
    return null;
  }

  const lastDose = history
    .filter((entry) => entry.medicationId === medication.id)
    .map((entry) => ({
      ...entry,
      administeredDate: toDate(entry.administeredAt),
    }))
    .filter((entry) => entry.administeredDate)
    .sort((a, b) => b.administeredDate - a.administeredDate)[0];

  let intervalHours = 0;
  const freqLower = frequency.toLowerCase();
  const timesPerDayMatch = freqLower.match(
    /(\d+)\s*(times|x)\s*(a|per)?\s*day/,
  );
  const everyHoursMatch = freqLower.match(/every\s*(\d+)\s*(hours|hrs|hr|h)/);
  const qHoursMatch = freqLower.match(/q\s*(\d+)\s*h/);

  if (freqLower.includes("daily") || freqLower.includes("once a day")) {
    intervalHours = 24;
  } else if (freqLower.includes("twice a day")) {
    intervalHours = 12;
  } else if (freqLower.includes("three times a day")) {
    intervalHours = 8;
  } else if (freqLower.includes("four times a day")) {
    intervalHours = 6;
  } else if (timesPerDayMatch) {
    intervalHours = 24 / parseInt(timesPerDayMatch[1], 10);
  } else if (everyHoursMatch) {
    intervalHours = parseInt(everyHoursMatch[1], 10);
  } else if (qHoursMatch) {
    intervalHours = parseInt(qHoursMatch[1], 10);
  }

  if (!intervalHours || Number.isNaN(intervalHours) || intervalHours <= 0) {
    return null;
  }

  const now = new Date();
  const start = toDate(startDate);
  const anchorDate = lastDose?.administeredDate || start;
  if (!anchorDate) return null;

  const nextDoseTime = new Date(anchorDate.getTime());
  while (nextDoseTime <= now) {
    nextDoseTime.setHours(nextDoseTime.getHours() + intervalHours);
  }

  return nextDoseTime;
};

export const getScheduledMedicationReminders = (
  medications = [],
  history = [],
) =>
  medications
    .map((medication) => ({
      ...medication,
      nextDose: calculateNextDose(medication, history),
    }))
    .filter((medication) => medication.nextDose)
    .sort((a, b) => a.nextDose - b.nextDose);
